<div class="content">
  <div class="table-header">
    <div class="row">
      <div class="col-md-6">
        <div class="brand-title">
          <h2>HOT SHOT / IGNITE Lite Firmware</h2>
        </div>
      </div>
      <div class="col-md-6">
        @if (authService.hasPermission('firmwares_manage', 2)) {
          <div class="brands-button">
            <button (click)="addEdit()" mat-raised-button><mat-icon>add_box</mat-icon></button>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="table-content">
    <mat-form-field appearance="fill">
      <mat-label>Filter</mat-label>
      <input matInput placeholder="Ex. Mia" #search>
    </mat-form-field>

    <div class="spinner-container" [hidden]="!(dataSource.loading$ | async)">
      <mat-spinner></mat-spinner>
    </div>

    <div class="mat-elevation-z8" [hidden]="dataSource.loading$ | async">
      <table mat-table [dataSource]="dataSource" matSort matSortDisableClear>
        <ng-container matColumnDef="sn">
          <th mat-header-cell *matHeaderCellDef style="width: 4%"> # </th>
          <td mat-cell *matCellDef="let row; let i = index"> {{ paginator.pageSize * paginator.pageIndex + i + 1 }} </td>
        </ng-container>
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef style="width: 2%">
            @if (authService.hasPermission('firmwares_manage', 2)) {
              <mat-checkbox (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            }
          </th>
          <td mat-cell *matCellDef="let row">
            @if (authService.hasPermission('firmwares_manage', 2)) {
              <mat-checkbox (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row.id) : null"
                [checked]="selection.isSelected(row.id)">
              </mat-checkbox>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 5%"> ID </th>
          <td mat-cell *matCellDef="let row"> {{ row.id }} </td>
        </ng-container>
        <ng-container matColumnDef="major_version">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%"> Major Version </th>
          <td mat-cell *matCellDef="let row"> {{row.major_version}}</td>
        </ng-container>
        <ng-container matColumnDef="hardware_version">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%"> Hardware Version </th>
          <td mat-cell *matCellDef="let row"> {{row.hardware_version}}</td>
        </ng-container>

        <ng-container matColumnDef="firmware_version">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%"> Firmware Version </th>
          <td mat-cell *matCellDef="let row"> {{row.firmware_version}} </td>
        </ng-container>

        <ng-container matColumnDef="zip_file">
          <th mat-header-cell *matHeaderCellDef style="width: 10%"> Zip File </th>
          <td mat-cell *matCellDef="let row">
            @if (row.zip_file_url) {
              <a [href]="row.zip_file_url" mat-raised-button>
                <mat-icon>file_download</mat-icon>Download
              </a>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header  style="width: 12%"> Description </th>
          <td mat-cell *matCellDef="let row"> {{row.description}} </td>
        </ng-container>

        <ng-container matColumnDef="created_at" style="width: 15%">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Release Date </th>
          <td mat-cell *matCellDef="let row"> {{ row.created_at | date:'medium'}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let row">
            @if (authService.hasPermission('firmwares_manage', 2)) {
              <button mat-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
            }
            <mat-menu #menu="matMenu" class="drop-down-menu">
              <button (click)="addEdit(row.id)" mat-menu-item><mat-icon>edit</mat-icon>Edit</button>
              <button (click)="delete(row.id)" mat-menu-item><mat-icon>delete</mat-icon>Delete</button>
            </mat-menu>
            @if (!authService.hasPermission('firmwares_manage', 2)) {
              <span>--</span>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="10">{{ search.value ? 'No data matching the filter "' + search.value + '"' : 'No Records Found' }}</td>
        </tr>
      </table>

      <div class="list-footer">
        <mat-paginator [pageSizeOptions]="[25, 50, 100, 1000]" [length]="dataSource.count$ | async" [pageSize]="25" aria-label="Select page of the records."></mat-paginator>
        @if (authService.hasPermission('firmwares_manage', 2)) {
          <mat-form-field appearance="fill" class="bulk-action">
            <mat-label>Bulk Action</mat-label>
            <select matNativeControl (change)="bulkActionConfirm()" [(ngModel)]="bulkAction" name="bulkAction">
              <option value="">Select Bulk Action</option>
              <option value="delete">Delete</option>
            </select>
          </mat-form-field>
        }
      </div>
    </div>
  </div>
</div>
